import styled from 'styled-components'

import CartItemsSummary from './CartItemsSummary'

const StyledCartItemsSummary = styled(CartItemsSummary)`
  border-top: none;
  max-width: unset;
  padding-top: 0;
  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
    border-radius: 0 0 4px 4px;
  }

  && {
    @media (min-width: 960px) {
      display: none;
    }
  }
`

export default StyledCartItemsSummary
